import { Box, Button, Tooltip, Typography } from "@mui/material";

import { PARTNERSHIP_DATA_EXAMPLE } from "constants/influencer";

interface Props {
  theme: "dark" | "light";
}

const SeeExample = ({ theme }: Props) => {
  return (
    <Tooltip
      enterTouchDelay={0}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: "white",
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: 3,
          },
        },
      }}
      title={
        <Box>
          <Typography sx={{ fontSize: 12 }}>
            See Partnership Data On Every Brand Card
          </Typography>
          <Box
            component="img"
            sx={{
              width: 280,
            }}
            src={PARTNERSHIP_DATA_EXAMPLE}
          />
        </Box>
      }
    >
      <Button
        sx={{
          fontSize: 10,
          textTransform: "none",
          color: theme === "dark" ? "primary.main" : "white",
          ml: { xs: -1, md: 0 },
        }}
      >
        See Example{" "}
        <Box
          sx={{ color: theme === "dark" ? "primary.main" : "white", ml: 0.5 }}
          component="i"
          className="fa-solid fa-circle-info"
        />
      </Button>
    </Tooltip>
  );
};

export default SeeExample;
